<template>
  <div id="resume" class="bg-gray-50 dark:to-dark-code bg-gradient-to-b dark:from-dark-green flex flex-col sm:flex-row justify-between items-center self-end">
    <div class="flex flex-col sm:flex-row w-full items-center">
      <ResumeMe />
      <!-- <ResumeHobbies /> -->
      <ResumeTools />
    </div>
  </div>
</template>

<script>
import ResumeTools from './ResumeTools.vue';
// import ResumeHobbies from './ResumeHobbies.vue';
import ResumeMe from './ResumeMe.vue';

export default {
  components: {
    ResumeTools,
    // ResumeHobbies,
    ResumeMe,
  },
  data() {
    return {
      listHobbies: this.$options.filters.lang('hobbies', 'resume'),
    };
  },
  methods: {
    getHobbiesnList() {
      return this.listHobbies;
    },
  },
}
</script>
